module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTYyMi4zIDE2My4zbDAuOSAwLjVBMzIgMzIgMCAwIDEgNjQwIDE5MnY2NDBhMzIgMzIgMCAwIDEtMzIgMzJoLTIuOGEzMiAzMiAwIDAgMS0zMi0zMmwtMC01NjMtMTMzLjcgMTI4LjFhMzIgMzIgMCAwIDEtNDQuMyAwbC0xLjUtMS40YTMxLjQgMzEuNCAwIDAgMSAwLTQ1LjNsMTg4LjItMTgwLjQgMS45LTEuOSAwLjMtMC4yIDAuNC0wLjQgMC44LTAuNy0xLjIgMS4xYTMyIDMyIDAgMCAxIDM4LjEtNC42eiIgZmlsbD0iIzAiIHAtaWQ9IjkxNyI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Ascending-outlined.svg
// module id = pwa4
// module chunks = 73